import { useDispatch, useSelector } from "react-redux";
import { IoClose } from "react-icons/io5"
import { FaCheck } from "react-icons/fa6";
import { setOpenAddArticleAPI, setOpenArticleManagment, setOpenChoiceComponentAR } from "../../Reducer/ModalSlice";
import { useState } from "react";
import axios from "axios";
import { changeValueAddedArticleAPI, clearAddedArticleAPI } from "../../Reducer/AddArticleInAPISlice";


function AddArticleAPI () {
    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const AddedArticleAPI = useSelector(state => state.AddArticleInAPISlice.AddedArticleAPI)
    const EditAddedArticleAPI = useSelector(state => state.AddArticleInAPISlice.EditAddedArticleAPI)    
    
    const dispatch = useDispatch()

    const [CancelTouch, setCancelTouch] = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [SuscessLoading, setSuscessLoading] = useState(false)

    const handleClickSaveButton = () => {
        setLoading(false)
        if(!AddedArticleAPI.Type)
        {
            setLoading(true)
            return(
                alert('Не выбран тип статьи')                
            )
        }

        if(!AddedArticleAPI.TransactionType)
        {
            setLoading(true)
            return(
                alert('Не выбран тип оплаты')                
            )
        }

        if(AddedArticleAPI.Name === '')
        {
            setLoading(true)
            return(
                alert('Не указано название')
            )
        }
        
        if(!EditAddedArticleAPI)
            return(
                axios.post(Server + 'articlesofmoneymovements', {
                        Name: AddedArticleAPI.Name,
                        Type: AddedArticleAPI.Type,
                        TransactionType: AddedArticleAPI.TransactionType,
                        OtherExpenditure: AddedArticleAPI.OtherExpenditure,
                        isRevenue: AddedArticleAPI.isRevenue
                }, {
                    headers: {
                    Authorization: 'Bearer ' + User.jwt,
                    },
                })
                .then(() => {
                    setLoading(true)
                    setSuscessLoading(true)
                    setTimeout(() => {
                        dispatch(setOpenAddArticleAPI(false))
                        dispatch(clearAddedArticleAPI())
                        dispatch(setOpenChoiceComponentAR(true))
                    }, 500)            
                })
                .catch(() => {
                    setLoading(true)
                    alert('При сохраниении произошла ошибка, повторите ввод')
                })
            )
        
            if(EditAddedArticleAPI)
            {
                return(                    
                    axios.put(Server + 'articlesofmoneymovements/' + AddedArticleAPI.id, {
                            Name: AddedArticleAPI.Name,
                            Type: AddedArticleAPI.Type,
                            TransactionType: AddedArticleAPI.TransactionType,
                            OtherExpenditure: AddedArticleAPI.OtherExpenditure,
                            isRevenue: AddedArticleAPI.isRevenue
                    }, {
                        headers: {
                        Authorization: 'Bearer ' + User.jwt,
                        },
                    })
                    .then(() => {
                        setLoading(true)
                        setSuscessLoading(true)
                        setTimeout(() => {
                            dispatch(setOpenAddArticleAPI(false))
                            dispatch(clearAddedArticleAPI())
                            dispatch(setOpenArticleManagment(true))
                        }, 500)            
                    })
                    .catch(() => {
                        setLoading(true)
                        alert('При сохраниении произошла ошибка, повторите ввод')
                    })
                )
            }            
    }

    if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )

    if(SuscessLoading && isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigCheckDiv"
                >
                    <FaCheck className="BigCheckIcon"/>
                </div>
            </div>
        )
    
    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalMainDiv"
            >
            <div
            className="ModalInformationDiv"
            >
                <div>

                </div>
                <div
                className="ModalInformationTextDiv"
                >
                    Добавление новой статьи
                </div>
                
                <button
                className="CloseModalIconDiv"
                onClick={(() => {
                    dispatch(setOpenAddArticleAPI(false))
                    
                    if(!EditAddedArticleAPI)
                        dispatch(setOpenChoiceComponentAR(true))

                    if(EditAddedArticleAPI)                    
                        dispatch(setOpenArticleManagment(true))
                        
                    dispatch(clearAddedArticleAPI())
                })} 
                onTouchStart={() => {
                    setCancelTouch(false)
                }}
                onTouchMove={() => {
                    setCancelTouch(true)
                }}
                onTouchCancel={() => {
                    setCancelTouch(true)
                }}
                onTouchEnd={((event) => {
                    event.preventDefault()
                    if(!CancelTouch)
                    {
                        dispatch(setOpenAddArticleAPI(false))

                        if(!EditAddedArticleAPI)
                            dispatch(setOpenChoiceComponentAR(true))

                        if(EditAddedArticleAPI)                        
                            dispatch(setOpenArticleManagment(true))
                            
                        dispatch(clearAddedArticleAPI())
                    }
                })}
                >
                    <IoClose
                    className="CloseModalIcon"
                    />
                </button>
            </div>
                <div
                className="InputModalMainDiv"
                >
                    <div
                    className="InputModalTextDiv"
                    >
                        {'Название: '} 
                    </div>
                    <input
                    className="InputModal AddCity"
                    value={AddedArticleAPI.Name}
                    id={'InputModal AddCity'}
                    onChange={((e) => {
                        dispatch(changeValueAddedArticleAPI({Type: 'Name', Value: e.target.value}))
                    })}
                    placeholder="Название статьи"
                    />
                </div>
                <div
                className="InputModalARGlobalDiv"
                >
                    <div
                    className="InputModalMainDiv ColumnMobile"
                    >
                        <div
                        className="InputModalTextDiv CenterMobile"
                        >
                            {'Тип: '} 
                        </div>
                        <div
                        className="ArticleAddAPIButtonDiv ColumnMobile"
                        >
                            <button
                            className={AddedArticleAPI.Type === 'income' ? "OneArticleAddAPIButton Active" : "OneArticleAddAPIButton"}
                            onClick={(() => {
                                if(AddedArticleAPI.Type !== 'income')
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: 'income'}))
                                    dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: false}))
                                }
                                else
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: false}))
                                }
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)                            
                                    if(AddedArticleAPI.Type !== 'income')
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: 'income'}))
                                        dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: false}))
                                    }
                                    else
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: false}))
                                    }                      
                            })}
                            >
                                Доход
                            </button>
                            <button
                            className={AddedArticleAPI.Type === 'expenditure' ? "OneArticleAddAPIButton Active" : "OneArticleAddAPIButton"}
                            onClick={(() => {
                                if(AddedArticleAPI.Type !== 'expenditure')
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: 'expenditure'}))
                                }
                                else
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: false}))
                                    dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: false}))
                                }
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)                            
                                    if(AddedArticleAPI.Type !== 'expenditure')
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: 'expenditure'}))
                                    }
                                    else
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: false}))
                                        dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: false}))
                                    }                      
                            })}
                            >
                                Расход
                            </button>
                            <button
                            className={AddedArticleAPI.Type === 'collection' ? "OneArticleAddAPIButton Active" : "OneArticleAddAPIButton"}
                            onClick={(() => {
                                if(AddedArticleAPI.Type !== 'collection')
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: 'collection'}))
                                    dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: false}))
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'Cash'}))
                                }
                                else
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: false}))
                                }
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)                            
                                    if(AddedArticleAPI.Type !== 'collection')
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: 'collection'}))
                                        dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: false}))
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'Cash'}))
                                    }
                                    else
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'Type', Value: false}))
                                    }                      
                            })}
                            >
                                Инкассация
                            </button>
                        </div>
                    </div>

                    {AddedArticleAPI.Type !== 'collection' &&
                    <div
                    className="InputModalMainDiv ColumnMobile"
                    >
                        <div
                        className="InputModalTextDiv CenterMobile"
                        >
                            {'Тип оплаты: '} 
                        </div>
                        <div
                        className="ArticleAddAPIButtonDiv ColumnMobile"
                        >
                            
                            <button
                            className={AddedArticleAPI.TransactionType === 'Cash' ? "OneArticleAddAPIButton Active" : "OneArticleAddAPIButton"}
                            onClick={(() => {
                                if(AddedArticleAPI.TransactionType !== 'Cash')
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'Cash'}))
                                }
                                else
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: false}))
                                }                      
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)                            
                                    if(AddedArticleAPI.TransactionType !== 'Cash')
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'Cash'}))
                                    }
                                    else
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: false}))
                                    }                      
                            })}
                            >
                                Наличные
                            </button>
                            <button
                            className={AddedArticleAPI.TransactionType === 'NonCash' ? "OneArticleAddAPIButton Active" : "OneArticleAddAPIButton"}
                            onClick={(() => {
                                if(AddedArticleAPI.TransactionType !== 'NonCash')
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'NonCash'}))
                                }
                                else
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: false}))
                                }                      
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)                            
                                    if(AddedArticleAPI.TransactionType !== 'NonCash')
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'NonCash'}))
                                    }
                                    else
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: false}))
                                    }                      
                            })}
                            >
                                Без наличные
                            </button>      
                            <button
                            className={AddedArticleAPI.TransactionType === 'All' ? "OneArticleAddAPIButton Active" : "OneArticleAddAPIButton"}
                            onClick={(() => {
                                if(AddedArticleAPI.TransactionType !== 'All')
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'All'}))
                                }
                                else
                                {
                                    dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: false}))
                                }                      
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)                            
                                    if(AddedArticleAPI.TransactionType !== 'All')
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: 'All'}))
                                    }
                                    else
                                    {
                                        dispatch(changeValueAddedArticleAPI({Type: 'TransactionType', Value: false}))
                                    }                      
                            })}
                            >
                                Оба типа
                            </button>                    
                        </div>
                    </div>
                    }
                </div>

                <div
                className="HiddenDesktop"
                >
                    {AddedArticleAPI.Type === 'expenditure' && 
                            <div
                            className="CheckBoxEnteringDataAR AddArticleAPI"
                            onClick={(() => {
                                dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: !AddedArticleAPI.OtherExpenditure}))
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                    dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: !AddedArticleAPI.OtherExpenditure}))
                            })}
                            >
                                <div
                                className={AddedArticleAPI.OtherExpenditure ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                >
                                    <FaCheck className={AddedArticleAPI.OtherExpenditure ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                </div>
                                <div>
                                    Является прочим расходом
                                </div>
                            </div>
                        }

                        {AddedArticleAPI.Type === 'income' && 
                            <div
                            className="CheckBoxEnteringDataAR AddArticleAPI"
                            onClick={(() => {
                                dispatch(changeValueAddedArticleAPI({Type: 'isRevenue', Value: !AddedArticleAPI.isRevenue}))
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) => {
                                event.preventDefault()
                                if(!CancelTouch)
                                    dispatch(changeValueAddedArticleAPI({Type: 'isRevenue', Value: !AddedArticleAPI.isRevenue}))
                            })}
                            >
                                <div
                                className={AddedArticleAPI.isRevenue ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                                >
                                    <FaCheck className={AddedArticleAPI.isRevenue ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                                </div>
                                <div>
                                    Является выручкой
                                </div>
                            </div>
                        }
                </div>

                <div
                className="ModalButtonsDiv"
                >
                    <button
                    className="ModalButton Cancle"
                    onClick={(() => {
                        dispatch(setOpenAddArticleAPI(false))
                        
                        if(!EditAddedArticleAPI)
                            dispatch(setOpenChoiceComponentAR(true))

                        if(EditAddedArticleAPI)                        
                            dispatch(setOpenArticleManagment(true))

                        dispatch(clearAddedArticleAPI())
                    })} 
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenAddArticleAPI(false))
                            
                            if(!EditAddedArticleAPI)
                                dispatch(setOpenChoiceComponentAR(true))
    
                            if(EditAddedArticleAPI)
                                dispatch(setOpenArticleManagment(true))

                            dispatch(clearAddedArticleAPI())
                        }
                    })}
                    >
                        Отмена
                    </button>

                    {AddedArticleAPI.Type === 'expenditure' && 
                        <div
                        className="CheckBoxEnteringDataAR AddArticleAPI HiddenMobile"
                        onClick={(() => {
                            dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: !AddedArticleAPI.OtherExpenditure}))
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                dispatch(changeValueAddedArticleAPI({Type: 'OtherExpenditure', Value: !AddedArticleAPI.OtherExpenditure}))
                        })}
                        >
                            <div
                            className={AddedArticleAPI.OtherExpenditure ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                            >
                                <FaCheck className={AddedArticleAPI.OtherExpenditure ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                            </div>
                            <div>
                                Является прочим расходом
                            </div>
                        </div>
                    }

                    {AddedArticleAPI.Type === 'income' && 
                        <div
                        className="CheckBoxEnteringDataAR AddArticleAPI HiddenMobile"
                        onClick={(() => {
                            dispatch(changeValueAddedArticleAPI({Type: 'isRevenue', Value: !AddedArticleAPI.isRevenue}))
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                dispatch(changeValueAddedArticleAPI({Type: 'isRevenue', Value: !AddedArticleAPI.isRevenue}))
                        })}
                        >
                            <div
                            className={AddedArticleAPI.isRevenue ? "ChekerEnteringDataAR Active" : "ChekerEnteringDataAR"}
                            >
                                <FaCheck className={AddedArticleAPI.isRevenue ? "ChekerEnteringDataARIcon Active" : "ChekerEnteringDataARIcon"}/>
                            </div>
                            <div>
                                Является выручкой
                            </div>
                        </div>
                    }

                    <button
                    className="ModalButton Save"
                    onClick={handleClickSaveButton}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            handleClickSaveButton()
                    })}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddArticleAPI;